module.exports = __webpack_public_path__ + "img/logo_white.b22f5678.png";